import React from 'react'
import { Tabs, Modal, Space, Input, message } from 'antd';
import Config from "../../../config/Config";
import WidgetAjax from '../../../widget/WidgetAjax';
import WidgetTable from '../../../widget/WidgetTable';
const { Search } = Input;
let filePath = Config.getFilePath();
let path = Config.getBasePath();
class application extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      jobState: [
        { label: "未查看", key: "0" },
        { label: "已查看", key: "1" },
        { label: "已约面试", key: "7" }
      ],
      tabValue: "0",
      tableOptions: {
        records: 10,
        check: {
          key: 'id',
          enable: true
        }
      },
      page: 1,
      columns: [
        { "name": "applying_time", "title": "报名时间", "type": "string", properties: {} },
        { "name": "JOBNAME", "title": "报名岗位", "type": "string", properties: {} },
        { "name": "ENTNAME", "title": "企业名称", "type": "string", properties: {} },
        { "name": "DISTRICT_CN", "title": "区域", "type": "string", properties: {} },
        { "name": "operate", "title": "操作", "type": "string", properties: { transform: 'operate', width: '230px' } },
      ],
      data: [],
      word: undefined,
      loading: true,
      confirmModal: {
        open: false,
        title: "删除",
        data: {}
      },
    }
  }
  componentDidMount() {
    this.loadData();
  }

  tabChange = async (value) => {
    await this.setState({ tabValue: value });
    this.loadData();
  }

  onSearch = async (value) => {
    await this.setState({ word: value, data: [], page: 1 });
    this.loadData();
  }

  /**
* 分页
* @param {} page 
* @param {*} pageSize 
*/
  onChangePage = async (page, pageSize) => {
    const { tableOptions } = this.state;
    await this.setState({ page, tableOptions: { ...tableOptions, records: pageSize } })
    this.loadData();
  }

  /**
* 表格数据
* @param {*} PAGES 
*/
  loadData = () => {
    const { page, tableOptions, tabValue, word } = this.state;
    let params = {
      RESULT: tabValue ? [tabValue] : undefined,
      word,
      page,
      records: tableOptions.records
    }
    this.setState({ loading: true })


    const onLoadData = (res) => {
      if (res.status === 0) {
        this.setState({ data: res.results, total: res.total });
      }
      else {
        this.setState({ data: [], total: 0 })
      }
      this.setState({ loading: false })
    }

    WidgetAjax.ajax({ url: path + '/job/application_list', params, callback: onLoadData });
  }

  notify = (type, record) => {
    switch (type) {
      case 'check':
        this.setState({ checkList: record });
        break;

      case "operate":
        {
          return <div className='table_operation'>
            <a onClick={() => this.remove([record?.id])}>删除</a>
          </div>
        }
    }
  }


  remove = (ids) => {
    let params = {
      ids,
    }
    const onConfirm = async (res) => {
      if (res.status == 0) {
        message.success("删除成功");
        this.setState({ checkList: [] });
        await this.ModalCancel();
        this.loadData();
      } else {
        message.success("删除失败" + res.message);
      }

    }
    WidgetAjax.ajax({ url: path + '/job/application_remove', params, callback: onConfirm });
  }

  inquiry = () => {
    const { checkList, confirmModal } = this.state;
    if (checkList && checkList.length > 0) {
      this.setState({
        confirmModal: {
          ...confirmModal,
          open: true,
          data: { ids: checkList },
          message: "你选择了" + checkList.length + "条数据,确认删除吗？"
        }
      })

    } else {
      message.info("请先选择数据!");
    }
  }

  ModalCancel = () => {
    const { confirmModal } = this.state;
    this.setState({
      confirmModal: {
        ...confirmModal,
        open: false,
      }
    })
  }





  render() {
    const { jobState, tabValue, columns, tableOptions, data, loading, page, total, checkList ,confirmModal } = this.state;
    return <div>
      <div className='tab_title'>报名记录</div>
      <div className='tab_tabs'>
        <Tabs items={jobState} value={tabValue} onChange={this.tabChange} />
        <div className='operation'>
          <Search placeholder="搜索岗位名称" onSearch={this.onSearch} style={{ width: 200 }} />
        </div>
      </div>
      <div className='table'>
        <div className='check_operation'>

          <div className='btn' onClick={() => { this.inquiry() }}>删除</div>
        </div>
        <WidgetTable data={data} columns={columns} options={tableOptions} loading={loading} page={page} notify={this.notify} pageTurning={this.onChangePage} total={total} />
      </div>
      {
        <Modal
          title={confirmModal?.title}
          open={confirmModal?.open}
          onOk={() => this.remove(checkList)}
          onCancel={this.ModalCancel}>

          <p>{confirmModal?.message}</p>
        </Modal>
      }

    </div>
  }
}

export default application;